import React, { useState, useEffect } from 'react';
import Home from './components/Home';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './components/HomePage';
import OrdersPage from './components/OrdersPage';
import RequestsPage from './components/RequestPage';
import CategoryItem from './components/sharedComponents/CategoryItem';
import SetupPage from './components/SetupPage';
import Header from './components/Header';
import AllProducts from './components/sharedComponents/All-products';
import ProductItem from './components/sharedComponents/ProductItem';
import { injectStyle } from "react-toastify/dist/inject-style";
import { ToastContainer } from 'react-toastify';
import WithWrapper from './components/WithWrapper';
import AccountingPage from './components/AccountingPage';
import Cart from './components/Cart';
import { ELSI_SHOP_URL, makeUrl } from './const/const';
import { CHECK_USER_REQUEST, getFetchRequest, PASSWORD_RESET_INFO } from './store/requests';
import { hintsService } from './components/sharedComponents/hintsService';
import { cartService } from './services/cartService';
import { userService } from './services/userService';

// Добавляем cartService в глобальную область для shared компонентов
window.cartService = cartService;

// Отладочная информация
console.log('CartService инициализирован:', {
    cartService: !!window.cartService,
    userService: !!window.userService,
    location: window.location.href,
    token: !!localStorage.getItem('token'),
});

const App = () => {
    const [isCollapsed, setIsCollapsed] = useState(null);
    const [defaultCustomer, setDefaultCustomer] = useState('');
    const [accessToken, setAccessToken] = useState('');

    useEffect(() => {
        injectStyle();
    }, []);    

    const succesCallback = (response) => {
        if(response && response.token) {
            setAccessToken(response.token);
            localStorage.setItem('token', response.token);
            
            // Принудительно загружаем информацию о пользователе после сохранения токена
            console.log('🔄 [App] Token received, triggering user info load...');
            userService.getCurrentUser().catch(error => {
                console.error('❌ [App] Failed to load user info after token save:', error);
            });
        } else {
            window.location.href = `${ELSI_SHOP_URL}/login`;
        }
    };

    const errorCallback = (e) => {
        console.log(e);
        window.location.href = `${ELSI_SHOP_URL}/login`;
    };
    
    useEffect(() => {
        const url = new URL(window.location.href);
        const code = url.searchParams.get('code');
        const isSetup = url.pathname === '/setup' && !!code;

        if (isSetup) {
            // В режиме первичной установки пароля: проверяем валидность кода и не требуем токен
            fetch(makeUrl([PASSWORD_RESET_INFO]), {
                credentials: 'include',
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ code }),
            }).then(res => {
                if (res.ok) {
                    // Разрешаем рендер без токена, доступ только к /setup
                    setAccessToken('setup-mode');
                } else {
                    window.location.href = `${ELSI_SHOP_URL}/login`;
                }
            }).catch(() => window.location.href = `${ELSI_SHOP_URL}/login`);
        } else {
            getFetchRequest(makeUrl([CHECK_USER_REQUEST]), succesCallback, errorCallback);
        }
    },[]);

    // UserService автоматически загружает информацию о пользователе при наличии токена

    if(!accessToken) {
        return null;
    }
    
    const handleCloseSearchList = (e) => {
        e.stopPropagation();
        // Do not prevent default here to allow native control interactions (e.g., checkboxes)
        hintsService.clearHintsList();
    };

    const CategoriesListWithWrapper = WithWrapper(AllProducts, isCollapsed);
    const ProductItemWithWrapper = WithWrapper(ProductItem, isCollapsed);
    const CategoryItemWithWrapper = WithWrapper(CategoryItem, isCollapsed); 

    return (
        accessToken&&<Router>
            <ToastContainer/>
            <Header setIsCollapsed={setIsCollapsed} isCollapsed={isCollapsed} defaultCustomer={defaultCustomer} setDefaultCustomer={setDefaultCustomer}/>
            <main className="main" onClick={handleCloseSearchList}>
                <Home isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
                <Routes>
                    <Route exact path="/" element={<Navigate to="/orders" replace />} />
                    <Route exact path="/home" element={<Navigate to="/orders" replace />} />
                    <Route exact path="/catalog" element={<CategoriesListWithWrapper/>} />
                    <Route exact path="/catalog/:id" element={<CategoryItemWithWrapper/>} />
                    <Route exact path="/catalog/search" element={<CategoryItemWithWrapper/>} />
                    <Route exact path="/catalog/product/:id" element={<ProductItemWithWrapper/>} />
                    <Route exact path="/orders" element={<OrdersPage isCollapsed={isCollapsed}/>} />
                    <Route exact path="/requests" element={<RequestsPage isCollapsed={isCollapsed}/>} />
                    <Route exact path="/accounting" element={<AccountingPage isCollapsed={isCollapsed} />} />
                    <Route exact path="/cart" element={<Cart isCollapsed={isCollapsed}/>} />
                    <Route exact path="/setup" element={<SetupPage isCollapsed={isCollapsed} defaultCustomer={defaultCustomer} setDefaultCustomer={setDefaultCustomer}/>} />
                </Routes>
            </main>
        </Router>
    );
};

export default App;
